import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { register } from "../services/LoginService";
import { setAuth } from "../Redux/authSlice";
import { FaUser, FaEnvelope, FaIdCard, FaLock, FaTag, FaPhone } from "react-icons/fa";

const RegisterPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const [telephone, setTelephone] = useState("");
    const [nomComplet, setNomComplet] = useState("");
    const [email, setEmail] = useState("");
    const [siret, setSiret] = useState("");
    const [password, setPassword] = useState("");
    const [promo, setPromo] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const promoCode = params.get("promo");
        if (promoCode) setPromo(promoCode);
    }, [location]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMessage("");

        if (!nomComplet || !email || !siret || !password || !telephone) {
            setLoading(false);
            setErrorMessage("Veuillez remplir tous les champs obligatoires.");
            return;
        }

        try {
            const response = await register(
                nomComplet,
                email,
                siret,
                password,
                telephone,
                promo
            );
            setLoading(false);

            if (response.success) {
                toast.success(response.message || "Inscription réussie !");
                dispatch(setAuth({ token: response.token, user: response.utilisateur }));
                navigate("/EspaceClient", {
                    state: { message: "Inscription réussie ✅" },
                });
            } else {
                setErrorMessage(response.message || "Erreur lors de l'inscription.");
            }
        } catch (error) {
            setLoading(false);
            setErrorMessage("Erreur inattendue.");
            console.error("Erreur register :", error);
        }
    };

    return (
        <div className="flex flex-col lg:flex-row w-screen min-h-screen lg:max-h-screen overflow-hidden lg:bg-blue-800 bg-color2">
            {/* FORMULAIRE */}
            <div className="w-full flex items-center justify-center px-4 lg:py-10 py-4">
                <div className="w-full max-w-xl bg-white lg:p-8 p-4 rounded-2xl shadow-lg">
                    <div className="lg:text-center text-start">
                        <h1 className="lg:text-4xl text-2xl font-bold text-blue-800">Créer un compte</h1>
                        <p className="text-sm lg:text-lg lg:font-semibold text-blue-700 mt-2">
                            Remplissez les informations pour vous inscrire.
                        </p>
                    </div>

                    {errorMessage && (
                        <div className="mt-4 bg-red-100 text-red-600 text-sm p-2 rounded">
                            {errorMessage}
                        </div>
                    )}
                    <form onSubmit={handleSubmit} className="flex flex-col gap-4 mt-6">
                        {/* Nom complet + Email */}
                        <div className="flex lg:flex-row flex-col gap-4">
                            <div className="flex-1 flex flex-col gap-1">
                                <label className="text-sm lg:text-base lg:font-semibold text-blue-700">
                                    Nom complet
                                </label>
                                <div className="relative">
                                    <FaUser className="absolute left-3 top-3 text-blue-600" />
                                    <input
                                        type="text"
                                        value={nomComplet}
                                        onChange={(e) => setNomComplet(e.target.value)}
                                        placeholder="Jean Dupont"
                                        className="w-full pl-10 pr-4 py-2 text-black text-sm lg:text-base rounded-lg border-color3 focus:border-color1 outline-none transition placeholder:text-blue-600 placeholder:font-semibold"
                                    />
                                </div>
                            </div>

                            <div className="flex-1 flex flex-col gap-1">
                                <label className="text-sm lg:text-base lg:font-semibold text-blue-700">
                                    Email
                                </label>
                                <div className="relative">
                                    <FaEnvelope className="absolute left-3 top-3 text-blue-600" />
                                    <input
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="contact@societe.com"
                                        className="w-full pl-10 pr-4 py-2 text-black text-sm lg:text-base rounded-lg border-color3 focus:border-color1 outline-none transition placeholder:text-blue-600 placeholder:font-semibold"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Téléphone */}
                        <div className="flex flex-col gap-1">
                            <label className="text-sm lg:text-base lg:font-semibold text-blue-700">
                                Téléphone
                            </label>
                            <div className="relative">
                                <FaPhone className="absolute left-3 top-3 text-blue-600" />
                                <input
                                    type="tel"
                                    value={telephone}
                                    onChange={(e) => setTelephone(e.target.value)}
                                    placeholder="+33 6 12 34 56 78"
                                    className="w-full pl-10 pr-4 py-2 text-black text-sm lg:text-base rounded-lg border-color3 focus:border-color1 outline-none transition placeholder:text-blue-600 placeholder:font-semibold"
                                />
                            </div>
                        </div>


                        {/* SIRET + Mot de passe */}
                        <div className="flex lg:flex-row flex-col gap-4">
                            <div className="flex-1 flex flex-col gap-1">
                                <label className="text-sm lg:text-base lg:font-semibold text-blue-700">
                                    Numéro SIRET
                                </label>
                                <div className="relative">
                                    <FaIdCard className="absolute left-3 top-3 text-blue-600" />
                                    <input
                                        type="text"
                                        value={siret}
                                        onChange={(e) => setSiret(e.target.value)}
                                        placeholder="12345678901234"
                                        className="w-full pl-10 pr-4 py-2 text-black text-sm lg:text-base rounded-lg border-color3 focus:border-color1 outline-none transition placeholder:text-blue-600 placeholder:font-semibold"
                                    />
                                </div>
                            </div>

                            <div className="flex-1 flex flex-col gap-1">
                                <label className="text-sm lg:text-base lg:font-semibold text-blue-700">
                                    Mot de passe
                                </label>
                                <div className="relative">
                                    <FaLock className="absolute left-3 top-3 text-blue-600" />
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder="********"
                                        className="w-full pl-10 pr-16 py-2 text-black text-sm lg:text-base rounded-lg border-color3 focus:border-color1 outline-none transition placeholder:text-blue-600 placeholder:font-semibold"
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setShowPassword(!showPassword)}
                                        className="absolute right-3 top-2 text-xs text-color3"
                                    >
                                        {showPassword ? "Masquer" : "Afficher"}
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Code promo */}
                        <div className="flex flex-col gap-1">
                            <label className="text-sm lg:text-base lg:font-semibold text-blue-700">
                                Code promo (facultatif)
                            </label>
                            <div className="relative">
                                <FaTag className="absolute left-3 top-3 text-blue-600" />
                                <input
                                    type="text"
                                    value={promo}
                                    onChange={(e) => setPromo(e.target.value)}
                                    placeholder="PROMO2025"
                                    className="w-full pl-10 pr-4 py-2 text-black text-sm lg:text-base rounded-lg border-color3 focus:border-color1 outline-none transition placeholder:text-blue-600 placeholder:font-semibold"
                                />
                            </div>
                        </div>

                        {/* Bouton */}
                        <button
                            type="submit"
                            disabled={loading}
                            className="bg-color1 text-white font-semibold py-2 px-4 rounded-lg hover:bg-color1/90 transition disabled:opacity-50 mt-2"
                        >
                            {loading ? "Inscription..." : "S'inscrire"}
                        </button>
                    </form>

                    <div className="text-sm text-center mt-4 text-blue-800">
                        Déjà un compte ?{" "}
                        <Link to="/login" className="text-blue-800 hover:underline">
                            Se connecter
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RegisterPage;
